// Clarity
$(document).ready(function(){

  $(".site-nav__dropdown-link:contains('Space')").css("color", "white");
  $('.m09').parent('div').addClass('m09-parent');
  $(".site-nav__dropdown-link:contains('Space')").addClass("space-nav");
  $(".mobile-nav__link:contains('Space')").addClass("space-nav");

  //   if ($('.site-header-sticky').hasClass("site-header")) {
  //     $('.icon__fallback-text').css({"position":"relative"});
  //   }

  //     $('#AnnouncementSlider').slick({
  //       adaptiveHeight: true,
  //       autoplay: true,
  //       autoplaySpeed: 5000
  // 	});

  $('.m04-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }

    ]
  });
  
  $('.sample-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }

    ]
  });


  $('.m02-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    adaptiveHeight: true,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          adaptiveHeight: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }

    ]
  });




  $(".feature-ingredient-image").hover(function(){
    $( this ).addClass( "hover" );
    $('.feature-ingredient[data-ingredient="'+$( this ).attr("data-ingredient")+'"]').addClass('hover');
  }, function(){
    $( this ).removeClass( "hover" );
    $('.feature-ingredient[data-ingredient="'+$( this ).attr("data-ingredient")+'"]').removeClass('hover');
  });

  $(".feature-ingredient").hover(function(){
    $( this ).addClass( "hover" );
    $('.feature-ingredient-image[data-ingredient="'+$( this ).attr("data-ingredient")+'"]').addClass('hover');
  }, function(){
    $( this ).removeClass( "hover" );
    $('.feature-ingredient-image[data-ingredient="'+$( this ).attr("data-ingredient")+'"]').removeClass('hover');
  });


  if ($(window).width() >= 800){	
    // do something here
    $('.product__thumbs').insertAfter('.product-single__sku');
  }	


  $('#addall').click(function() {

    var productJSON = [];
    $('.product-routine .grid-product').each(function() {
      var product = JSON.parse($(this).find('.product-grid-item-json').first().text().replace(/\n\r\t/g, "").replace(/\s{2,}/g,''));
      productJSON.push({ quantity: 1, id: product.id, properties: product.properties })
    })

    $('#addall').addClass('btn--loading');

    var xhr = new XMLHttpRequest();
    xhr.open("POST", '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify({
      items: productJSON}))
    xhr.onload = function() {
      $('#addall').removeClass('btn--loading');
      $('body').trigger('added.ajaxProduct', this.$addToCart);
    };
  })

  $('.grid-product__link').on('click', function(e) {
   
     
    if($(e.target).hasClass('add-grid-item')) {
      e.preventDefault();
      if($(e.target).attr('disabled')){
        
      } else {
        var anchorTag = this;
        $(this).find('[data-add-grid-item]').first().addClass('btn--loading');
        var product = JSON.parse($(this).find('.product-grid-item-json').text().replace(/\n\r\t/g, "").replace(/\s{2,}/g,''));
        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify({
          items: [product]}))
        xhr.onload = function() {
          if($(e.target).text() == 'Pick'){
          	location.reload();
          } else {
          	$(anchorTag).find('[data-add-grid-item]').first().removeClass('btn--loading');
            $('body').trigger('added.ajaxProduct', this.$addToCart);
          }
        };	
      }
     
    }  else {
        console.log('false')
      }
  })

  $('.add-to-bag').on('click', function(){
    $(this).addClass('btn--loading');
    var anchorTag = this;
    var productJSON = [{ quantity: 1, id: $(this).attr('data-product-variant-id') }];
    var xhr = new XMLHttpRequest();
    xhr.open("POST", '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify({
      items: productJSON}))
    xhr.onload = function() {
      $(anchorTag).removeClass('btn--loading');
      $('body').trigger('added.ajaxProduct', this.$addToCart);
    };	
  })

  	
});


!function(e){e.fn.shorten=function(s){"use strict";var t={showChars:100,minHideChars:10,ellipsesText:"...",moreText:"more",lessText:"less",onLess:function(){},onMore:function(){},errMsg:null,force:!1};return s&&e.extend(t,s),e(this).data("jquery.shorten")&&!t.force?!1:(e(this).data("jquery.shorten",!0),e(document).off("click",".morelink"),e(document).on({click:function(){var s=e(this);return s.hasClass("less")?(s.removeClass("less"),s.html(t.moreText),s.parent().prev().animate({height:"0%"},function(){s.parent().prev().prev().show()}).hide("fast",function(){t.onLess()})):(s.addClass("less"),s.html(t.lessText),s.parent().prev().animate({height:"100%"},function(){s.parent().prev().prev().hide()}).show("fast",function(){t.onMore()})),!1}},".morelink"),this.each(function(){var s=e(this),n=s.html(),r=s.text().length;if(r>t.showChars+t.minHideChars){var o=n.substr(0,t.showChars);if(o.indexOf("<")>=0){for(var a=!1,i="",h=0,l=[],c=null,f=0,u=0;u<=t.showChars;f++)if("<"!=n[f]||a||(a=!0,c=n.substring(f+1,n.indexOf(">",f)),"/"==c[0]?c!="/"+l[0]?t.errMsg="ERROR en HTML: the top of the stack should be the tag that closes":l.shift():"br"!=c.toLowerCase()&&l.unshift(c)),a&&">"==n[f]&&(a=!1),a)i+=n.charAt(f);else if(u++,h<=t.showChars)i+=n.charAt(f),h++;else if(l.length>0){for(j=0;j<l.length;j++)i+="</"+l[j]+">";break}o=e("<div/>").html(i+'<span class="ellip">'+t.ellipsesText+"</span>").html()}else o+=t.ellipsesText;var m='<div class="shortcontent">'+o+'</div><div class="allcontent">'+n+'</div><span><button type="button" class="morelink">'+t.moreText+"</button></span>";s.html(m),s.find(".allcontent").hide(),e(".shortcontent p:last",s).css("margin-bottom",0)}}))}}(jQuery);

$('.ingredients-list').shorten({
  showChars: 300,
  moreText: 'Läs mer',
  lessText: 'Läs mindre',
  onMore: function(){
    $('.ingredients-list .allcontent').attr('tabindex','-1').focus();
  }
});

$('.product-single__description-full').shorten({
  showChars: 300,
  moreText: 'Läs mer',
  lessText: 'Läs mindre',
  onMore: function(){
    $('.product-single__description-full .allcontent').attr('tabindex','-1').focus();
  }
});

$('.product-grid-description').shorten({
  showChars: 0,
  moreText: 'Läs mer',
  lessText: 'Läs mindre',
  onMore: function(){
    $('.product-single__description-full .allcontent').attr('tabindex','-1').focus();
  }
});


// handle links with @href started with '#' only
// $(document).on('click', 'a[href^="#"]', function(e) {
//     // target element id
//     var id = $(this).attr('href');

//     // target element
//     var $id = $(id);
//     if ($id.length === 0) {
//         return;
//     }

//     // prevent standard hash navigation (avoid blinking in IE)
//     e.preventDefault();

//     // top position relative to the document
//     var pos = $id.offset().top;

//     // animated top scrolling
//     $('body, html').animate({scrollTop: pos});
// });

$(".scrollTo").on('click', function(e) {
  e.preventDefault();
  var target = $(this).attr('href');
  $('html, body').animate({
    scrollTop: ($(target).offset().top)
  }, 2000);
});

$( '.mobile-nav__link[href$="mobile"]' ).parent('div').addClass('hide');
$( '.mobile-nav__link[href^="/products"]' ).parent('div').addClass('hide');
$( '.site-nav__dropdown-link.site-nav__dropdown-link--top-level[href^="/products"]' ).parent('div').addClass('hide');

$("#CartGiftWrapAgree").on('change', function(){
  if(this.checked) {
    $(".gift-note-area").removeClass('hide');
  } else {
    $(".gift-note-area").addClass('hide')
  }
})

$('.cart__product-qty').on('change', function(){
  $('.cart__update').click();
});

$(document).on('drawerOpen', function(event){
     $('.ajaxcart__quantity input').trigger('change');
  });

$('body').on('DOMNodeInserted', '.page-content.page-content--product', function(e) {
  //     console.log('node inserted = ' + $(e.target).attr('class'));
  if($(e.target).attr('class') === 'spr-container'){
    $('.spr-summary-actions-newreview').on('click', function(){
      if($('.spr-form').css('display') == 'block')
      {
        $('.spr-summary-actions-newreview').addClass('close-btn');
        $( ".close-btn" ).append( "<span class='close-x' style=''>X</span>" );
      } else {
        $('.spr-summary-actions-newreview').removeClass('close-btn');
        $(this).find('.close-x').remove()
      }
    });	
  }
});

$('body').on('DOMNodeInserted', '.page-content.page-content--product', function(e) {
  //     console.log('node inserted = ' + $(e.target).attr('class'));
    $('.address-new-toggle').on('click', function(){
      if($('#AddressNewForm').css('display') == 'block')
      {
        $('#AddressNewForm').addClass('close-btn');
        $( ".close-btn" ).append( "<span class='close-x' style=''>X</span>" );
      } else {
        $('#AddressNewForm').removeClass('close-btn');
        $(this).find('.close-x').remove()
      }
    });	

});




// var all_links = document.querySelectorAll('a');
// for (var i = 0; i < all_links.length; i++){
//   var a = all_links[i];
//   if(a.hostname != location.hostname) {
//     a.rel = 'noopener';
//     a.target = '_blank';
//   }
// }

$(document).ready(function () {
    $("#eye").click(function () {
        if ($(".show-password").attr("type") === "password") {
            $(".show-password").attr("type", "text");
        } else {
            $(".show-password").attr("type", "password");
        }
    });

  $(document).on('click', '.js-qty__adjust', function() {
    $(this).parent().find('input').trigger('change');
  });
  

  $(document).on('change', '.ajaxcart__quantity input', function() {
     var id = $(this).data('id');
     var value = $(this).val();
     $('form.cart input[data-id="'+ id +'"]').val(value);
  });

  $(document).on('drawerClosed', function(event){
    $('.cart__update').click();
  });
  

   $('.ajaxcart__quantity').find('input').on('change', function() {
     $('body').trigger('added.ajaxProduct');
  })
   $('.ajaxcart__quantity').find('.js-qty__adjust.js-qty__adjust--minus').on('click', function(){
      $('body').trigger('added.ajaxProduct');
   })
   $('.ajaxcart__quantity').find('.js-qty__adjust.js-qty__adjust--plus').on('click',function(){
      $('body').trigger('added.ajaxProduct');
   })
   
   let first_trigger = false;
  let drawer = 0;
//     $('body').on('updateCart.ajaxcart', function(){
//       console.log('update');
//       if(first_trigger) {
// //         if(!searchParams.has('drawer')) {
// //           if(!(searchParams.get('drawer') == "true" || searchParams.get('drawer') == true)) {
// //           	location.href = location.href + "?drawer=true";
// //         	console.log(`location.href = ${location.href}`);
// //           }
// //         }
//         drawer = drawer + 1;
//          localStorage.setItem("drawer", drawer);
        
//         if(localStorage.getItem("drawer") == null || localStorage.getItem("drawer") == ) {
//         	localStorage.setItem("drawer", 1);
//                 	location.reload();
//         }
        

//       } else {
//       	first_trigger = true;
//       }
//     })
    
// //     let searchParams = new URLSearchParams(window.location.search);
//   console.log(`searchParams = ${localStorage.getItem("drawer")}`);
// //   if(searchParams.has('drawer')) {
// //     if(searchParams.get('drawer') == "true" || searchParams.get('drawer') == true) {
// //       console.log(`searchParams.. = ${searchParams.get('drawer')}`);
// //     	 $('body').trigger('added.ajaxProduct');
// //       window.location.href = location.href.split('?')[0];
// //     }
//      if(localStorage.getItem("drawer") != null && localStorage.getItem("drawer") == 2) {
//      	 localStorage.setItem("drawer", 0);
//         $('body').trigger('added.ajaxProduct');
//      }
// //   }
  
  
  $('.sample-slider .sample-checkbox').change(function(){
    if($(this).is(':checked')){
       var productJSON = [{ quantity: 1, id:$(this).prop('id') }];
        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify({
          items: productJSON}))
        xhr.onload = function() {
             location.reload();
        };	

    } else {
      var productJSON = { };
      productJSON['' + $(this).prop('id')] = 0;
        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/cart/update.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify({
          updates: productJSON}))
        xhr.onload = function() {
             location.reload();
        };	
    }
    }) 
});

var $p =$('.m19-summary-links p');
    $p.first().html(function(){
        return $p.map(function(){
            return $(this).html() ;
        }).get().join(' ')
    }).end().filter(':gt(0)').remove();

function ScrollToDivId(id) {
    $("div").removeClass("flashit");
    $("#" + id).addClass("flashit");
    $('html,body').animate({
        scrollTop: $("#" + id).offset().top
    }, 'slow');
}

$('#m09-select').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
    ScrollToDivId(valueSelected);
});




$(document).ready(function() {
  stickyProduct()
});
$(document).scroll(function() {
  stickyProduct()
});

function stickyProduct(){
  var y = $(this).scrollTop();
  if (y > 600) {
    $('#sticky-product-parent').fadeIn();
    $('body').addClass('sticky-product-active');
  } else {
    $('#sticky-product-parent').fadeOut();
    $('body').removeClass('sticky-product-active');
  }
}



/***************** m09 spy ****************/
$(document).ready(function() {
  var section = document.querySelectorAll(".m09-parent");
  var sections = {};
  var i = 0;

  var sectionTags = [];
  $(".m09-parent").find('a').each(function(e){
    var id = $(this).prop('href').split("#")[1];
    var tagId = "#"+id;
    sections[id] = $(tagId).parent().parent().offset().top;
  });

  window.onscroll = function() {
    var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    for (i in sections) {

      if (sections[i] <= scrollPosition) {
        $(".m09-parent").find('a[href*=' + i + ']').siblings().removeClass('active');
        $(".m09-parent").find('a[href*=' + i + ']').addClass('active');
        $(".m09-parent").find("#m09-select").val(i);
      }
    }
  };
})

/***************** read more button ****************/
$(document).ready(function() {
  $(".read-more__btn").each(function(){
    var text = $('.read-more__text');
    
    var btn = $(this);
    btn.on('click', function(){
      btn.hide();
      text.slideDown();
    })
  });
});

/******** wishlist *******/
$(document).on('click', '.cart-btn', function(e){
  var btn = e.currentTarget;
  const interval = setInterval(() => {
    console.log(btn.innerHTML);
    if (btn.innerHTML == 'Adding...'){
      btn.innerHTML = 'Lägga till...';
    }else if (btn.innerHTML == "Added In Cart"){
      btn.innerText = 'I kundvagn';
      clearInterval(interval);
    }
  },1)
});

$(document).on('click', '.cart-all-btn', function(e){
  var btn = e.currentTarget;
  var btnText = btn.textContent;
  const interval = setInterval(() => {
    console.log(btn.innerHTML);
    if (btn.innerHTML == "Added In Cart"){
      btn.innerText = 'I kundvagn';
      clearInterval(interval);
    }
  },1)
});

document.addEventListener('collection:reinit', () => {
  iwishCheckColl();
})

const app = {
  newsletter: {
    init: function() {
      const newsletterBar = document.querySelector('.newsletter-section'),
        currentUrl = window.location.href,
        url = new URL(currentUrl),
        isCustomerPosted = url.searchParams.get('customer_posted');
      if (newsletterBar && isCustomerPosted == "true") {
        setTimeout(function() {
          $("html, body").animate({
            scrollTop: $(newsletterBar).offset().top - 180 
          }, 300);
        }, 1000);
      }
    }
  },
  cartRefresh: {
    page: document.querySelector('.template-cart'),
    els: document.querySelectorAll('[data-cart-refresh]'),
    
    init: function() {
      if (!this.page || this.els.lenght == 0) return;
      
      this.els.forEach(qty => {
        qty.readonly = true;
        qty.value = qty.max;
        qty.dispatchEvent(new Event('change'));
      });
    }
  },
  init: function() {
    this.cartRefresh.init();
    this.newsletter.init();
  }
}
window.app = app;
window.addEventListener('DOMContentLoaded', function() {
  app.init();
});